/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto';
import type { Wealthlane_AwardService_Dtos_Release_CalculateTaxByFilterDto } from '../models/Wealthlane_AwardService_Dtos_Release_CalculateTaxByFilterDto';
import type { Wealthlane_AwardService_Dtos_Release_CreateReleaseByFilterDto } from '../models/Wealthlane_AwardService_Dtos_Release_CreateReleaseByFilterDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseDto';
import type { Wealthlane_AwardService_Dtos_Release_UpdateFMVByFilterDto } from '../models/Wealthlane_AwardService_Dtos_Release_UpdateFMVByFilterDto';
import type { Wealthlane_AwardService_Dtos_Release_UpdateReleaseByFilterDto } from '../models/Wealthlane_AwardService_Dtos_Release_UpdateReleaseByFilterDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseFilterService {

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseFilterReleaseByFilter(
        requestBody?: Wealthlane_AwardService_Dtos_Release_CreateReleaseByFilterDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-filter/release-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppReleaseFilterReleaseByFilter(
        requestBody?: Wealthlane_AwardService_Dtos_Release_UpdateReleaseByFilterDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/release-filter/release-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppReleaseFilterFMVByFilter(
        requestBody?: Wealthlane_AwardService_Dtos_Release_UpdateFMVByFilterDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/release-filter/f-mVBy-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseFilterCalculateTaxByFilter(
        requestBody?: Wealthlane_AwardService_Dtos_Release_CalculateTaxByFilterDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ApplyFMVReleaseResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-filter/calculate-tax-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
